import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import { cn } from "../../utils/index";
import styles from "./tabs.module.css";

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List> & {
    appearance?: "legacy" | "system";
  }
>(({ className, appearance = "legacy", ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    data-appearance={appearance}
    className={cn(
      "inline-flex h-9 gap-1 items-center justify-center text-gray-700",
      styles.list,
      className,
    )}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center whitespace-nowrap border border-gray-300 rounded-t-xs px-3 py-1 text-sm font-medium ring-offset-gray-300 transition-all focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-gray-300 hover:bg-gray-400 data-[state=active]:bg-white data-[state=active]:text-gray-700",
      styles.trigger,
      className,
    )}
    {...props}
  />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content> & {
    appearance?: "legacy" | "system";
  }
>(({ className, appearance = "legacy", ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    data-appearance={appearance}
    className={cn(
      " ring-offset-background rounded-sm rounded-tl-none p-3 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border border-gray-300",
      styles.content,
      className,
    )}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
